// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__PCFFL","go_back":"_styles_go_back__nZOVS"};